import React, { useState, ReactNode } from 'react'
import { Layout, Menu } from 'antd'
import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  DesktopOutlined,
  PieChartOutlined,
  UserOutlined,
  MoneyCollectOutlined,
  BookOutlined,
  VideoCameraOutlined,
  UsergroupAddOutlined,
  AudioOutlined,
  MessageOutlined,
  PoweroffOutlined,
} from '@ant-design/icons'
import LogoSVG from '../assets/LogoSVG'
import { Link, useNavigate } from 'react-router-dom'
import { logoutAdmin } from '../redux/features/admin/adminSlice'
import { useDispatch } from 'react-redux'
import { UsersPage } from '../pages/content/users/UsersPage'

const { Header, Sider, Content } = Layout
const { SubMenu } = Menu

interface AppLayoutProps {
  children: ReactNode
}

const AppLayout: React.FC<AppLayoutProps> = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false)
  const [openKeys, setOpenKeys] = useState(['sub1'])
  const dispatch = useDispatch<any>()
  const navigate = useNavigate()
  const toggle = () => {
    setCollapsed(!collapsed)
  }

  // Handle submenu open change events
  const onOpenChange = (keys: string[]) => {
    setOpenKeys(keys)
  }

  const handleLogout = () => {
    dispatch(logoutAdmin())
    navigate('/login') // Redirect to login page after logout
  }

  return (
    <Layout
      style={{
        height: '100vh',
      }}
    >
      <Sider trigger={null} collapsible collapsed={collapsed} theme="light">
        <div
          className="logo"
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '10px',
          }}
        >
          <LogoSVG height={60} width={180} />
        </div>
        <Menu
          theme="light"
          mode="inline"
          defaultSelectedKeys={['1']}
          defaultOpenKeys={openKeys}
          onOpenChange={onOpenChange}
          items={[
            {
              key: '1',
              icon: <DesktopOutlined />,
              label: <Link to="/">Home</Link>,
            },
            {
              key: '6',
              icon: <UsergroupAddOutlined />,
              label: <Link to="/users">Users</Link>,
            },
            {
              key: '2',
              icon: <VideoCameraOutlined />,
              label: <Link to="/videos">Videos</Link>,
            },
            {
              key: '3',
              icon: <AudioOutlined />,
              label: <Link to="/audios">Audio</Link>,
            },
            {
              key: '4',
              icon: <BookOutlined />,
              label: <Link to="/books">Books</Link>,
            },
            {
              key: '5',
              icon: <MessageOutlined />,
              label: <Link to="/comments">Comments</Link>,
            },
            {
              key: '7',
              icon: <PoweroffOutlined style={{ color: 'red' }} />,
              label: 'Logout',
              onClick: handleLogout,
            },
          ]}
        />
      </Sider>

      <Layout className="site-layout">
        <Header
          className="site-layout-background"
          style={{
            padding: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            background: 'white',
          }}
        >
          {React.createElement(
            collapsed ? MenuUnfoldOutlined : MenuFoldOutlined,
            {
              className: 'trigger',
              onClick: toggle,
              style: { color: 'black', marginLeft: 16 },
            }
          )}
        </Header>
        {/* <div
          style={{
            padding: 24,
            background: '#fff',
            overflow: 'auto',
          }}
        >
          Breadclums
        </div> */}
        <Content
          style={{
            padding: 24,
            background: '#fff',
            overflow: 'auto',
          }}
        >
          {children}
        </Content>
      </Layout>
    </Layout>
  )
}

export default AppLayout
